<template>
  <div class="productList" ref="container">
    <form @submit.prevent="submitForm">
      <div class="search bg-color-red acea-row row-between-wrapper">
        <div class="input acea-row row-between-wrapper">
          <span class="iconfont icon-sousuo"></span>
          <input placeholder="搜索商品信息" v-model="where.keyword" />
        </div>
        <div
          class="iconfont"
          :class="Switch === true ? 'icon-pailie' : 'icon-tupianpailie'"
          @click="switchTap"
        ></div>
      </div>
    </form>
    <div class="nav acea-row row-middle">
      <div
        class="item"
        :class="title ? 'font-color-red' : ''"
        @click="set_where(0)"
      >
        {{ title ? title : "默认" }}
      </div>
      <div class="item" @click="set_where(1)">
        价格
        <img src="@assets/images/horn.png" v-if="price === 0" />
        <img src="@assets/images/up.png" v-if="price === 1" />
        <img src="@assets/images/down.png" v-if="price === 2" />
      </div>
      <div class="item" @click="set_where(2)">
        销量
        <img src="@assets/images/horn.png" v-if="stock === 0" />
        <img src="@assets/images/up.png" v-if="stock === 1" />
        <img src="@assets/images/down.png" v-if="stock === 2" />
      </div>
      <!-- down -->
      <div
        class="item"
        :class="nows ? 'font-color-red' : ''"
        @click="set_where(3)"
      >
        新品
      </div>
    </div>
    <div
      style="overflow:hidden;"
      class="list acea-row row-between-wrapper"
      :class="Switch === true ? 'on' : ''"
      ref="container"
    >
      <router-link
        :to="{
          path: '/detail/' + item.id
        }"
        class="item"
        :class="Switch === true ? 'on' : ''"
        v-for="(item, index) in productList"
        :key="index"
        :title="item.store_name"
        
      >
        <div class="pictrue" :class="Switch === true ? 'on' : ''">
          <img :src="item.image" :class="Switch === true ? 'on' : ''" />
        </div>
        <div class="text" :class="Switch === true ? 'on' : ''">
          <img :src="youUrl" v-if="item.is_good == 1" class="you" :class="Switch === true ? '' : 'hong'" />
          <!-- <div class="name line1">{{ item.store_name }}</div> -->
          <div class="line1" :class="Switch === true ? 'shu' : ''">{{ item.store_name }}</div>
          <div class="tit" :class="Switch === true ? 'shu' : ''" style="color:#b3b4af;font-size: .28rem;">{{ item.store_info }}</div>
          <div
            class="money font-color-red"
            :class="Switch === true ? 'onx' : ''"
          >
            ￥<span class="num">{{ item.price }}</span>
           <span v-if=" item.zheqian_price > 0">折后价</span>
            <span class="yuan" v-if="item.zheqian_price > 0">￥{{ item.zheqian_price }}</span>
            <div class="sale" v-if="item.ficti" :class="Switch === true ? '' : 'fuk'">月销{{ item.ficti }}</div>
            <div class="sale" v-else :class="Switch === true ? '' : 'fuk'">月销{{ item.ficti }}</div>
          </div>
          <div class="mon" :class="Switch === true ? '' : 'biao'" >
            <div class="label"   v-if="item.is_hot == 1">热卖</div>
            <div class="label"   v-if="item.is_benefit == 1">促销</div>
            <div class="label"   v-if="item.is_best == 1">精品</div>
            <div class="label"   v-if="item.is_new == 1">新品</div>
            <div class="label"   v-if="item.is_postage == 1">包邮</div>
          </div>
          <div class="mon">
            <span class="atext" v-if="is_tirp== 0 && item.lingshou_notice">{{ item.lingshou_notice }}</span>
            <span class="atext"  v-else-if="is_tirp== 0 && item.lingshou_notice==''" >七天无理由退换</span>
             <span class="atext"  v-else-if="is_tirp== 1 && item.pifa_notice" >{{ item.pifa_notice }}</span>
              <span class="atext"  v-else-if="is_tirp== 1 && item.pifa_notice==''" >品质问题.联系客服</span>
          </div>
        </div>
      </router-link>
      
     

    </div>
    <Loading :loaded="loadend" :loading="loading"></Loading>
    <div
      class="noCommodity"
      v-cloak
      style="background-color: #fff;"
      v-if="productList.length === 0 && where.page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noGood.png" class="image" />
      </div>
    </div>
    <Recommend v-if="productList.length === 0 && where.page > 1"></Recommend>
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import { getProducts,getGuigeTitle } from "@api/store";
import debounce from "lodash.debounce";
import Loading from "@components/Loading";

export default {
  name: "Category_List",
  components: {
    Recommend,
    Loading
  },
  props: {},
  data: function() {
    const { s = "", id = 0, title = "" } = this.$route.query;

    return {
      youUrl: "http://tieyige.fsrcwl.cn/images/label.png",
      hostProduct: [],
      productList: [],
      url:'',
      is_tirp:'',
      Switch: true,
      where: {
        gid:0,
        page: 1,
        limit: 8,
        keyword: s,
        sid: id, //二级分类id
        news: 0,
        priceOrder: "",
        salesOrder: ""
      },
      title: title && id ? title : "",
      loadTitle: "",
      loading: false,
      loadend: false,
      price: 0,
      stock: 0,
      nows: false
    };
  },
  watch: {
    title() {
      this.updateTitle();
    },
    $route(to) {
      if (to.name !== "Category_List") return;
      const { s = "", id = 0, title = "" } = to.query;

      if (s !== this.where.keyword || id !== this.where.sid) {
        this.where.keyword = s;
        this.loadend = false;
        this.loading = false;
        this.where.page = 1;
        this.where.sid = id;
        this.title = title && id ? title : "";
        this.nows = false;
        this.$set(this, "productList", []);
        this.price = 0;
        this.stock = 0;
        this.get_product_list();
      }
    }
  },
// beforeRouteEnter (to, from, next){
//       console.log(from.name);
//       next(vm=>{
//         // vm.$set(this, "routefrom", from.name);
//         //  console.log('-------------')
//         //vm.routefrom(from.name);//vm当成this
//         vm.geturl(from.name);
//       });
//   },
  mounted: function() {
    this.updateTitle();
    let gid = this.$route.query.gid;
    let gg = this.$route.query.gg;
    this.where.gg = gg;
    this.where.gid = gid;
    this.get_product_list();
    if(parseInt(gid)>0){
      getGuigeTitle(gid).then(res=>{
        let title = res.data[0];
        document.title = title;
      });
    }
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.get_product_list();
    });
  },
  methods: {
    updateTitle() {
      //document.title = this.title || this.$route.meta.title;
     
      //console.log(document.title)
    },
  
    get_product_list: debounce(function() {
      var that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      this.setWhere();
      that.where.dian = that.$route.query.dian;
      let q = that.where;
      console.log("-----where------");
      console.log(q);
      getProducts(q).then(res => {
        that.loading = false;
          console.log("-----productList------");
          console.log(res.data);
        that.productList.push.apply(that.productList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
        document.title="产品分类";
      });
    }, 300),
    submitForm: function() {
      this.$set(this, "productList", []);
      this.where.page = 1;
      this.loadend = false;
      this.loading = false;
      this.get_product_list();
    },
    //点击事件处理
    set_where: function(index) {
      let that = this;
      switch (index) {
        case 0:
          return that.$router.push({ path: "/category" });
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.$set(that, "productList", []);
      that.where.page = 1;
      that.loadend = false;
      that.get_product_list();
    },
    //设置where条件
    setWhere: function() {
      let that = this;
      if (that.price === 0) {
        that.where.priceOrder = "";
      } else if (that.price === 1) {
        that.where.priceOrder = "asc";
      } else if (that.price === 2) {
        that.where.priceOrder = "desc";
      }
      if (that.stock === 0) {
        that.where.salesOrder = "";
      } else if (that.stock === 1) {
        that.where.salesOrder = "asc";
      } else if (that.stock === 2) {
        that.where.salesOrder = "desc";
      }
      that.where.news = that.nows ? "1" : "0";
    },
    switchTap: function() {
      let that = this;
      that.Switch = !that.Switch;
    }
  }
};
</script>
<style scoped>
.noCommodity {
  border-top: 3px solid #f5f5f5;
  padding-bottom: 1px;
}
.shu{
  white-space: normal;
    width: 54%;
    overflow: unset;
}
.mon .label{font-size: .23rem;border:1px solid #eee;padding:0 .06rem;border-radius: 16%;color: #ff4200;float: left;margin:0 .03rem}
.mon .atext{color: #a4a4a4;}
.text .you{float: left;margin-right: 0.1rem;width: 16%;border-radius: .05rem;}
.hong{width: 30%!important;margin-bottom: .05rem;}
.fuk{margin-left: unset!important;}
.biao{margin-top: .1rem!important;}
.mon {margin-top: .2rem;font-size: 0.26rem;color: #ff4200;height: auto;overflow: hidden;}
.productList .list .item .text .money .sale {font-size: .26rem;color: #aaa;width: auto;display: inline-block;margin-left: .2rem;float: unset;}
.font-color-red{color: #ff4200 !important;}
.productList .list .item .text .money{font-weight: unset;}
/* .onx{margin-top:.2rem;width:58%;} */
</style>
